import React from "react";

import { switchCompanyURL } from "Dashboard/EmployerUrls";
import { Helmet } from "react-helmet";
import companyToken from "Utils/companyToken";
import Heartbeat from "ZeroRuby/snippets/heartbeat";

import { NavItem } from "Cobalt/NavItem";
import { Card } from "Common/Card";
import Footer from "Common/Footer";
import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import ThemeInstaller from "Common/ThemeInstaller";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

const branding = "toast";

export default function Chrome({ children, title, headerContent }) {
  const showMultiPageFlow = true;

  const renderNavBar = () => {
    const rightContent = [];
    rightContent.push(
      <NavItem key="logOut" eventKey="logOut" href="/logout">
        <Icon icon="sign-out-alt" flavor="solid" mx={3} />
        Log out
      </NavItem>,
    );

    return <ResponsiveTopBar branding={branding} collapseOnSelect={false} rightContent={rightContent} />;
  };

  return (
    <div>
      <Helmet titleTemplate="SimplyInsured - %s" title={title} defaultTitle="SimplyInsured" />
      {renderNavBar()}
      {headerContent && (
        <Grid mt={5} p={0}>
          {headerContent}
        </Grid>
      )}

      <Div className="min-h-dvh">
        <Grid componentClass={showMultiPageFlow ? "div" : Card} mt={showMultiPageFlow ? 0 : 5} p={0}>
          {children}
        </Grid>
      </Div>
      <Footer />
      <Heartbeat />
      <ThemeInstaller />
    </div>
  );
}
